<template>
  <div>


      <div class="row dvContent">
        <BodyLoader :loading="firstLoad"></BodyLoader>

        <div class="col s12 dvContentMain">
          <div class="dvSectionTitleOpts">
            <div class="dvSectionTitleOpts-title">
              <span class="icon-fs_user"></span>{{pageTitle}}
            </div> <!-- dvSectionTitleOpts-title -->
          </div> <!-- dvSectionTitleOpts -->

          <div class="dvClientForm">

            <div class="dvClientFormBox" id="client-info-container">
              <div class="dvClientFormBox-header valign-wrapper">
                <div class="dvClientFormBox-header-title">
                  Client Information
                </div>
              </div>
              <div class="dvClientFormBox-content">
                <div class="row">
                  <form class="col s12">
                    <div class="row">
                      <div class="col l4 m12 s12">
                        <div class="dvClientFormBox-content-item">
                          <v-text-field
                            ref="fname"
                            v-model="client.first_name"
                            maxlength="100"
                            label="First Name"
                            required
                            :readonly="forUpdate"
                            hint="* Required"
                            prepend-icon="icon-fs_user">
                          </v-text-field>
                        </div><!-- dvClientFormBox-content-item -->
                      </div><!-- col -->

                      <div class="col l4 m12 s12">
                        <div class="dvClientFormBox-content-item">
                          <v-text-field
                            v-model="client.last_name"
                            maxlength="100"
                            label="Last Name"
                            required
                            :readonly="forUpdate"
                            hint="* Required"
                            prepend-icon="icon-fs_user">
                          </v-text-field>
                        </div><!-- dvClientFormBox-content-item -->
                      </div><!-- col -->

                      <div class="col l4 m12 s12">
                        <div class="dvClientFormBox-content-item">
                          <v-text-field
                            v-model="client.email"
                            maxlength="100"
                            label="E-mail Address"
                            required
                            hint="* Required (e.g. juan.delacruz@email.com)"
                            prepend-icon="icon-content_email">
                          </v-text-field>
                        </div><!-- dvClientFormBox-content-item -->
                      </div><!-- col -->

                      <div class="col l4 m12 s12">
                        <div class="dvClientFormBox-content-item">
                          <v-text-field
                            v-model="client.mobile_no"
                            maxlength="15"
                            label="Mobile Number"
                            type="tel"
                            prepend-icon="icon-content_mobile">
                          </v-text-field>
                        </div><!-- dvClientFormBox-content-item -->
                      </div><!-- col -->

                      <div class="col l4 m12 s12">
                        <div class="dvClientFormBox-content-item">
                          <v-select
                            v-model="client.country"
                            :items="countries"
                            label="Country"
                            menu-props="auto"
                            placeholder="Select a Country"
                            item-text="name"
                            prepend-icon="icon-fs_world"
                            item-value="code">
                          </v-select>
                        </div><!-- dvClientFormBox-content-item -->
                      </div><!-- col -->

                      <div class="col l4 m12 s12">
                        <div class="dvClientFormBox-content-item">
                          <v-text-field
                            v-model="client.state_province"
                            maxlength="200"
                            label="State / Province"
                            prepend-icon="icon-content_location">
                          </v-text-field>
                        </div><!-- dvClientFormBox-content-item -->
                      </div><!-- col -->

                      <div class="col l4 m12 s12">
                        <div class="dvClientFormBox-content-item">
                          <v-text-field
                            v-model="client.city"
                            maxlength="200"
                            label="City"
                            prepend-icon="icon-content_location">
                          </v-text-field>
                        </div><!-- dvClientFormBox-content-item -->
                      </div><!-- col -->

                    </div><!-- row -->
                  </form><!-- form -->
                </div><!-- row -->
              </div><!-- dvClientFormBox-content -->
            </div> <!-- dvClientFormBox -->
            <div id="projectHolder">
              <ProjectInfo
                :projectIdx="index"
                :projectsCnt="projectInquiries.length"
                :projectInquiryDetails="projectInquiry"
                :projectData="projectData"
                @confirm="confirm"
                v-for="(projectInquiry, index) in projectInquiries" :key="index">
              </ProjectInfo>
            </div>

            <div id="personal-info-container" class="dvClientFormBox" v-if="showPersonalInfo">
              <div class="dvClientFormBox-header valign-wrapper">
                <div class="dvClientFormBox-header-title">
                  Personal Information
                </div>
                <a @click="showPersonalInfo = false" href="javascript:void(0)" class="dvClientFormBox-header-btn btn waves-effect waves-light flexCenterAll">remove <span class="icon-action_close"></span></a>
              </div>
              <div class="dvClientFormBox-content">
                <div class="row">
                  <form class="col s12">
                    <div class="row">

                      <div class="col l4 m12 s12">
                        <div class="dvClientFormBox-content-item">
                          <v-text-field
                            v-model="personalInfo.company_name"
                            maxlength="200"
                            label="Company Name"
                            prepend-icon="icon-content_office">
                          </v-text-field>
                        </div><!-- dvClientFormBox-content-item -->
                      </div><!-- col -->

                      <div class="col l4 m12 s12">
                        <div class="dvClientFormBox-content-item">
                          <v-text-field
                            v-model="personalInfo.occupation"
                            maxlength="100"
                            label="Occupation"
                            prepend-icon="icon-content_work">
                          </v-text-field>
                        </div><!-- dvClientFormBox-content-item -->
                      </div><!-- col -->

                      <div class="col l4 m12 s12">
                        <div class="dvClientFormBox-content-item">
                          <v-select
                            v-model="personalInfo.home_ownership_id"
                            :items="homeOwnerships"
                            menu-props="auto"
                            label="Home Ownership"
                            placeholder="Select Ownership"
                            prepend-icon="icon-nav_chevron_right"
                            item-text="name"
                            item-value="id">
                          </v-select>
                        </div><!-- dvClientFormBox-content-item -->
                      </div><!-- col -->

                      <div class="col l4 m12 s12">
                        <div class="dvClientFormBox-content-item">
                          <v-select
                            v-model="personalInfo.monthly_income_id"
                            :items="monthlyIncomes"
                            menu-props="auto"
                            label="Monthly Household Income"
                            placeholder="Select Income"
                            prepend-icon="icon-nav_chevron_right"
                            item-text="name"
                            item-value="id"
                            required>
                          </v-select>
                        </div><!-- dvClientFormBox-content-item -->
                      </div><!-- col -->

                    </div><!-- row -->
                  </form><!-- form -->
                </div><!-- row -->
              </div><!-- dvClientFormBox-content -->
            </div> <!-- dvClientFormBox -->

            <div id="home-address-container" class="dvClientFormBox" v-if="showHomeAddress">
              <div class="dvClientFormBox-header valign-wrapper">
                <div class="dvClientFormBox-header-title">
                  Home Address
                </div>
                <a @click="showHomeAddress = false" href="javascript:void(0)" class="dvClientFormBox-header-btn btn waves-effect waves-light flexCenterAll">remove <span class="icon-action_close"></span></a>
              </div>
              <div class="dvClientFormBox-content">
                <div class="row">
                  <form class="col s12">
                    <div class="row">

                      <div class="col l4 m12 s12">
                        <div class="dvClientFormBox-content-item">
                          <v-text-field
                            v-model="homeAddress.address1"
                            maxlength="255"
                            label="Address 1"
                            prepend-icon="icon-content_home">
                          </v-text-field>
                        </div><!-- dvClientFormBox-content-item -->
                      </div><!-- col -->

                      <div class="col l4 m12 s12">
                        <div class="dvClientFormBox-content-item">
                          <v-text-field
                            v-model="homeAddress.city"
                            maxlength="100"
                            label="City"
                            prepend-icon="icon-content_location">
                          </v-text-field>
                        </div><!-- dvClientFormBox-content-item -->
                      </div><!-- col -->

                      <div class="col l4 m12 s12">
                        <div class="dvClientFormBox-content-item">
                          <v-select
                            v-model="homeAddress.country"
                            :items="countries"
                            menu-props="auto"
                            label="Country"
                            placeholder="Select a Country"
                            prepend-icon="icon-fs_world"
                            item-text="name"
                            item-value="code">
                          </v-select>
                        </div><!-- dvClientFormBox-content-item -->
                      </div><!-- col -->

                    </div><!-- row -->
                  </form><!-- form -->
                </div><!-- row -->
              </div><!-- dvClientFormBox-content -->
            </div> <!-- dvClientFormBox -->

            <div class="row dvClientFormAdd">
              <div class="col s12 m6 l3">
                <a
                  @click="addNewProject()"
                  v-scroll-to="{
                    el: '#project-inq'+(projectInquiries.length-1),
                    offset: -17
                  }"
                  href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools isSecondary flexCenterAll"><span class="icon-action_add_circle"></span>Project Inquiry</a>
              </div>
              <div class="col s12 m6 l3">
                <a
                  :class="{ disabled: showPersonalInfo }"
                  @click="showPersonalInfo = !showPersonalInfo"
                  v-scroll-to="{
                    el: '#personal-info-container',
                    offset: -17
                  }"
                  href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools isSecondary flexCenterAll"><span class="icon-action_add_circle"></span>Personal Information</a>
              </div>
              <div class="col s12 m6 l3">
                <a
                  :class="{ disabled: showHomeAddress }"
                  @click="showHomeAddress = true"
                  v-scroll-to="{
                    el: '#home-address-container',
                    offset: -17
                  }"
                  href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools isSecondary flexCenterAll"><span class="icon-action_add_circle"></span>Home Address</a>
              </div>

            </div> <!-- dvClientFormAdd -->

            <DataPrivacyConsent :dataPrivacy="dataPrivacy" :isAgreeDisabled="false"></DataPrivacyConsent>

          </div> <!-- dvClientForm -->

        </div> <!-- dvContentMain -->

        <div class="col s12 dvContentTools formSubmit">
          <div class="dvContentTools-fx"></div>
          <div class="dvContentTools-content">
            <a
              @click="saveReferral()"

              href="javascript:void(0)" class="col s6 waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
              <span class="icon-action_check" v-if="!saving"></span>
              {{ saving ? 'Saving...' : 'Save' }}
            </a>
            <!--
              <a
                @click="saveReferral()"
                :class="{ disabled: saving }"
                href="javascript:void(0)" class="col s6 waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
                <span class="icon-action_check" v-if="!saving"></span>
                {{ saving ? 'Saving...' : 'Save' }}
              </a> -->
              <a
                @click="$router.go(-1)"
                :class="{ disabled: saving }"
                href="javascript:void(0)" class="col s6 waves-effect waves-light btn btn-Tools btnCancel flexCenterAll"><span class="icon-action_cancel"></span>Cancel</a>
          </div> <!-- dvContentTools-formSubmit -->

          <div class="dvContentTools-page">
            <a href="#" class="waves-effect waves-dark btn btn-Tools isSecondary flexCenterAll"><span class="icon-content_email"></span><div class="hide-on-small-only">Email</div></a>
            <a href="#" class="waves-effect waves-dark btn btn-Tools isSecondary flexCenterAll"><span class="icon-action_print"></span><div class="hide-on-small-only">Print</div></a>
            <ToTop></ToTop>
          </div>

        </div>

      </div> <!-- dvContent -->
      <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>
      <ConfirmationDialog
        :dialog="dialog"
        @doConfirm="doConfirm">
      </ConfirmationDialog>
  </div>
</template>

<style>
  .v-picker__title.primary {
    background-color: #1867c0 !important;
    border-color: #1867c0 !important;
  }

  .v-date-picker-years li.active {
    color: #1867c0 !important;
    caret-color: #1867c0 !important;
}

.v-date-picker-table tr{
  border-bottom: 0px solid rgba(0,0,0,0.12);
}

.v-date-picker-table .v-btn.v-btn--active {
    color: #FFFFFF;
}

.v-application .accent {
    background-color: #005caf !important;
    border-color: #005caf !important;
}

.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: #005caf !important;
}

.v-date-picker-table--month td {
    width: 33.333333%;
    height: 56px;
    vertical-align: middle;
    text-align: center;
    padding: 0
}

.v-date-picker-table--date td {
    width: 45px;
    padding:0
}

.v-date-picker-table td, .v-date-picker-table th {
    text-align: center;
    position: relative;
}

tr {
    display: table-row;
    vertical-align: inherit;
    border-color: inherit;
}

table {
    border-collapse: separate;
    border-spacing: 2px;
}
</style>

<script>
  import ProjectInfo from './ProjectInfo.vue'
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import ConfirmationDialog from '@/components/confirmation_view/ConfirmationDialog.vue'
  import BodyLoader from '@/components/BodyLoader.vue'
  import ToTop from '@/components/totop/ToTop.vue'
  import DataPrivacyConsent from '@/components/DataPrivacyConsent.vue'

  export default {
    name: 'referrals-main',
    data: () => ({
      dataPrivacy: {
        isAgree: false,
        isAgreeDisabled: false
      },
      team_id: '',
      loadedCnt: 0,
      firstLoad: true,
      dialog: {
        show: false,
        title: '',
        body: '',
        action: '',
        id: ''
      },
      snackbarDetails: {
        color: 'sb-success',
        msg: '',
        show: false
      },
      id: '',
      pageTitle: 'Add New Client',
      date_picker: false,
      date: null,
      defaultCountry: '',
      client: {
        first_name: '',
        last_name: '',
        email: '',
        mobile_no: '',
        country: '',
        state_province: '',
        city: ''
      },
      countries: [],
      projectInquiries: [],
      projectInquiryDetails: {
        id: '',
        project_interested_in: '',
        project_location: '',
        property: '',
        project_location_name: ''
      },
      showPersonalInfo: false,
      personalInfo: {
        company_name: '',
        occupation: '',
        home_ownership_id: '',
        monthly_income_id: '',
        civil_status_name: '',
        home_ownership_name: '',
        monthly_income_name: ''
      },
      showHomeAddress: false,
      homeAddress: {
        address1: '',
        city: '',
        country: ''
      },
      referralSummary: {
        pending: '',
        valid: '',
        expiring: '',
        archive: ''
      },
      civilStatuses: [],
      homeOwnerships: [],
      monthlyIncomes: [],
      projectData: {
        projects: [],
        projectLocations: []
      },
      saving: false,
      removedProjectInqIds: [],
      loaded: false
    }),
    watch: {
      loadedCnt: function() {
        if(this.loadedCnt == 2){
          this.firstLoad = false
        }
     },
      date_picker (val) {
        val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
      },
      $route (to, from){
        //
        // if(to.name == 'referrals_add_new'){
        //   console.log("add new")
        // }else{
        //   console.log("edit")
        // }

        this.initData()

      }
    },
    computed: {
      forUpdate: function(){
        return this.id ? true : false
      }
    },
    methods: {
      confirm (action){
        if(action.type == 'remove-project-inq'){
          this.dialog = {
            show: true,
            title: 'Remove Project Inquiry',
            body: 'Are you sure you want to remove this project inquiry?',
            icon: 'icon-action_delete',
            positionBtn: 'Remove',
            negativeBtn: 'Cancel',
            actionType: action.type,
            id: action.id,
            idx: action.idx
          }

        }

      },
      doConfirm (){
        this.dialog.show = false

        if(this.dialog.actionType == 'remove-project-inq'){
          this.removeProject(this.dialog.idx, this.dialog.id)
        }

      },
      save (date){
        this.date_picker = false
      },
      removeProject (idx, id){
        if(id.length > 0){
          this.removedProjectInqIds.push(id)
        }
        this.projectInquiries.splice(idx, 1)
      },
      addNewProject (){
        let data = {
          id: '',
          project_interested_in: '',
          project_location: '',
          property: '',
          project_location_name: ''
        }
        this.projectInquiries.push(data)
      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      },
      filterByReferralStatus (filerStatus) {
        this.$router.push({ name: 'referral_status', params: { status: filerStatus } })
      },
      getLatestReferralsSummary () {
        this.$http.plain.get('api/referrals/summary')
          .then(response => {
            this.referralSummary = response.data
            this.loadedCnt++
          })
          .catch(error => {
            this.showMessage(error, 'sb-failed')
          })
      },
      getDefaultData () {
        this.loading = true
        let self = this
        this.$http.plain.get('api/default-data/projects')
          .then(response => {
            this.homeOwnerships = response.data.home_ownerships
            this.monthlyIncomes = response.data.monthly_incomes
            this.countries = response.data.countries

            this.projectData = {
              projects: response.data.projects,
              projectLocations: response.data.project_locations
            }
          })
          .catch(error => {
            console.log(error);
          })
          .then(function () {
            self.loading = false
            self.loadedCnt++
          })
      },
      getProjectName: function(id){
        return this.projectData.projects.filter(project => {
          return project.id == id
        })
      },
      getProjectLocationName: function(id){
        return this.projectData.projectLocations.filter(location => {
          return location.id == id
        })
      },
      getPropertyTypeName: function(id){
        return this.projectData.projectTypes.filter(propertyType => {
          return propertyType.id == id
        })
      },
      getPaymentSchemeName: function(id){
        return this.projectData.paymentSchemes.filter(project => {
          return project.id == id
        })
      },
      getPriceRangeName: function(id){
        return this.projectData.projectPriceRanges.filter(range => {
          return range.id == id
        })
      },
      getPrimaryPurposeName: function(id){
        return this.projectData.primaryPurposes.filter(purpose => {
          return purpose.id == id
        })
      },
      getCivilStatusName: function(id){
        return this.civilStatuses.filter(civil_status => {
          return civil_status.id == id
        })
      },
      getHomeOwnerShipName: function(id){
        return this.homeOwnerships.filter(home_ownership => {
          return home_ownership.id == id
        })
      },
      getMonthlyHouseholdName: function(id){
        return this.monthlyIncomes.filter(monthly_income => {
          return monthly_income.id == id
        })
      },
      saveReferral (){
        if(this.saving){
          return false;
        }

        let self = this

        if (this.showPersonalInfo){

          if(this.personalInfo.home_ownership_id.length > 0 && this.personalInfo.home_ownership_id != '0'){
            let home_ownership_name = this.getHomeOwnerShipName(self.personalInfo.home_ownership_id)
            this.personalInfo.home_ownership_name = home_ownership_name[0].name
          }else{
            this.personalInfo.home_ownership_name = ''
          }

          if(this.personalInfo.monthly_income_id.length > 0 && this.personalInfo.monthly_income_id != '0'){
            let monthly_income_name = this.getMonthlyHouseholdName(self.personalInfo.monthly_income_id)
            this.personalInfo.monthly_income_name = monthly_income_name[0].name
          }else{
            this.personalInfo.monthly_income_name = ''
          }

          this.client['personalInfo'] = this.personalInfo
        }


        if (this.showHomeAddress){
          this.client['homeAddress'] = this.homeAddress
        }else{
          delete this.client['homeAddress'];
        }

        Object.keys(this.projectInquiries).forEach(function(key) {

          if(self.projectInquiries[key].project_interested_in.length > 0 && self.projectInquiries[key].project_interested_in != '0'){
            let property = self.getProjectName(self.projectInquiries[key].project_interested_in)
            if(property.length == 0){
              self.projectInquiries[key].property = ''
              self.projectInquiries[key].project_interested_in = ''
            }else{
              self.projectInquiries[key].property = property[0].name
            }
          }else{
            self.projectInquiries[key].property = ''
          }

          if(self.projectInquiries[key].project_location.length > 0 && self.projectInquiries[key].project_location != '0'){
            let project_location = self.getProjectLocationName(self.projectInquiries[key].project_location)
            if(project_location.length == 0){
              self.projectInquiries[key].project_location_name = ''
              self.projectInquiries[key].project_location = ''
            }else{
              self.projectInquiries[key].project_location_name = project_location[0].name
            }
          }else{
            self.projectInquiries[key].project_location_name = ''
          }

        });

        this.client['projectInquiries'] = this.projectInquiries
        this.client['histories'] = []
        this.client['is_agree_privacy_consent'] = this.dataPrivacy.isAgree
        this.client['team'] = {}
        this.saving = true

        if(this.forUpdate){
          if(this.removedProjectInqIds.length > 0){
            this.client['removeProjectInqs'] = this.removedProjectInqIds.join(',')
          }
          this.update()
        }else{
          this.addNew()
        }
      },
      addNew () {
        let self = this

        this.$http.secured.post('api/referrals', this.client)
          .then(response => {
            let status = 'valid'
            if(response.data.pending == '1'){
              status = 'pending'
            }
            self.$router.push({ name: 'referral_status', params: { status: status }, query: { added: 'yes', msg: response.data.message } })
          })
          .catch(error => {
            if (error.response) {
              let errors = error.response.data.messages
              let msg = []
              Object.keys(errors).forEach(key => {
                msg.push(errors[key])
              })
              this.showMessage(msg.join(','), 'sb-failed')

            }else{
              this.showMessage("Something went wrong! Please try again.", 'sb-failed')
            }
          })
          .then(function () {
            self.saving = false
          })
      },
      update () {

        let self = this
        this.$http.secured.put('api/referrals/'+this.client.id+'?team_id='+this.team_id, this.client)
          .then(response => {
            this.showMessage(response.data.message, 'sb-success')
            this.getReferral()

            self.$router.push({ name: 'admin_teams_client_view', params: { id: this.id, team_id: this.team_id }, query: { updated: 'yes', msg: response.data.message } })
          })
          .catch(error => {
            if (error.response.status === 500) {
              this.showMessage("Something went wrong! Please try again.", 'sb-failed')
            }else{
              let errors = error.response.data.messages
              let msg = []
              Object.keys(errors).forEach(key => {
                msg.push(errors[key])
              })
              this.showMessage(msg.join(','), 'sb-failed')
            }
          })
          .then(function () {
            self.saving = false
            window.scroll(0, 0)
          })
      },
      getReferral () {
        this.homeAddress = {}
        this.projectInquiryDetails = []
        this.personalInfo = {}
        let self = this

        this.$http.plain.get('api/referrals/'+ this.id+'?team_id='+this.team_id)
          .then(response => {
            this.client = response.data

            this.dataPrivacy.isAgree = true
            this.dataPrivacy.isAgreeDisabled = true

            if(response.data.projectInquiries){
              this.projectInquiries = response.data.projectInquiries
            }else{
              this.projectInquiries = []
              this.projectInquiryDetails = {
                id: '',
                project_interested_in: '',
                project_location: ''
              }
              this.projectInquiries.push(this.projectInquiryDetails)
            }

            this.personalInfo.company_name = this.client.company_name
            this.personalInfo.occupation = this.client.occupation
            this.personalInfo.home_ownership_id = this.client.home_ownership_id
            this.personalInfo.monthly_income_id = this.client.monthly_income_id

            if((this.personalInfo.company_name && this.personalInfo.company_name.length > 0)
              || (this.personalInfo.occupation && this.personalInfo.occupation.length > 0)
              || (this.personalInfo.home_ownership_id && this.personalInfo.home_ownership_id > 0)
              || (this.personalInfo.monthly_income_id && this.personalInfo.monthly_income_id > 0)){
              this.showPersonalInfo = true
            }

            if(response.data.homeAddress)
            {
                this.showHomeAddress = true
                this.homeAddress = response.data.homeAddress
            }else{
              this.homeAddress = {
                address1: '',
                city: '',
                country: this.defaultCountry ? this.defaultCountry : ''
              }
            }

          })
          .catch(error => {
            console.log(error);
          })
          .then(function () {
            if(!self.loaded){
              if(self.$route.query.target){
                var options = {
                  container: "body",
                  duration: 800,
                  easing: "ease",
                  offset: -17,
                  force: true,
                  cancelable: true,
                  onStart: false,
                  onDone: false,
                  onCancel: false,
                  x: false,
                  y: true
                }
                self.$scrollTo("#"+self.$route.query.target, 500, options)
                self.loaded = true
            }


            }
          })
        },
        initData () {
          this.loadedCnt = 0
          this.firstLoad = true
          if(this.$route.params.id){
            this.pageTitle = 'Edit Client'
            this.id = this.$route.params.id
            this.getReferral()
          }else{
            this.id = '',
            this.pageTitle = 'Add New Client'
            this.date_picker = false
            this.date =  null
            this.client = {
              first_name: '',
              last_name: '',
              email: '',
              mobile_no: '',
              country: '',
              state_province: '',
              city: ''
            }
            this.countries = []
            this.projectInquiries = []
            this.projectInquiryDetails = {
              id: '',
              project_interested_in: '',
              project_location: ''
            }
            this.showPersonalInfo = false
            this.personalInfo = {
              company_name: '',
              occupation: '',
              home_ownership_id: '',
              monthly_income_id: '',
              home_ownership_name: '',
              monthly_income_name: ''
            }
            this.showHomeAddress = false,
            this.homeAddress = {
              address1: '',
              city: '',
              country: ''
            },

            this.referralSummary = {
              pending: '',
              valid: '',
              expiring: '',
              archive: ''
            }
            this.homeOwnerships = []
            this.monthlyIncomes = []
            this.projectData = {
              projects: [],
              projectLocations: []
            }
            this.saving = false
            this.removedProjectInqIds = []
            this.loaded = false
          }

          this.getLatestReferralsSummary()
          this.getDefaultData()
          this.projectInquiries.push(this.projectInquiryDetails)
        }
    },
    mounted() {
      this.team_id = this.$route.params.team_id
      this.defaultCountry = this.$store.getters.getTeam.country
      this.initData()

      this.$refs.fname.focus()
    },
    components: {
      ProjectInfo,
      SnackBar,
      ConfirmationDialog,
      BodyLoader,
      ToTop,
      DataPrivacyConsent
    }
  }



</script>
